/**
* @param {Object} options
* @param {boolean} [options.withCredentials]
* @param {string} [options.action]
* @param {Object} [options.header]
*/

export default function ajax(options) {
  return new Promise((res, rej)=>{
    if (typeof XMLHttpRequest === 'undefined') {
      return;
    }
    const xhr = new XMLHttpRequest();
    const action = options.action;
    xhr.open('post', action, true);
    if (options.withCredentials && 'withCredentials' in xhr) {
      xhr.withCredentials = true;
    }
    const headers = options.headers || {};

    for (let item in headers) {
      if (headers.hasOwnProperty(item) && headers[item] !== null) {
        xhr.setRequestHeader(item, headers[item]);
      }
    }

    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) {
        rej(xhr.statusText);
        return;
      }
      res(JSON.parse(xhr.responseText));
    };
    xhr.onerror = () => rej(xhr.statusText);
    xhr.send(options.data);
  });
}



// WEBPACK FOOTER //
// ./src/lib/ajax.js